export function canParseToNumber (number) {
  return typeof number !== 'object' && !isNaN(parseFloat(number))
}

export function canParseToInteger (number) {
  return canParseToNumber(number) && Number.isInteger(Number(number))
}

export function getInteger (number, defaultValue = NaN) {
  return canParseToInteger(number) ? parseInt(number, 10) : defaultValue
}
